module.exports = __webpack_public_path__ + "img/vertical_3_7_3016.61814b8c.png";